export default __webpack_public_path__ + "static/media/page1-img_04_original.a3567576.jpg";